import React, { FC, useEffect, useState } from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { BsEyeFill as ViewIcon } from '@react-icons/all-files/bs/BsEyeFill';
import { Skeleton } from '@material-ui/lab';
import { createUseStyles } from '../../../../../../../theming';
import { Link } from 'react-router-dom';
import useDeal from '../../../../../../../hooks/api/useDeal';
import Deal from '../../../../../../../interfaces/api/Deal';

interface Props {
  dealId: string;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
  },
});

const DealField: FC<Props> = ({ dealId }) => {
  const [deal, setDeal] = useState<Deal>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { get: getDeal } = useDeal();
  const classes = useStyles();

  useEffect(() => {
    setError(undefined);
    setLoading(true);

    getDeal(dealId)
      .then((deal) => {
        setDeal(deal);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, [dealId]);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <div className={classes.root}>
      <TextField
        variant='outlined'
        label='Affaire concernée'
        defaultValue={deal?.name}
        InputProps={{
          readOnly: true,
          endAdornment: deal?.legacyId && (
            <IconButton component={Link} to={`/dashboard/deal/${deal.legacyId}`}>
              <ViewIcon color='#0000008a' />
            </IconButton>
          ),
        }}
        fullWidth
      />
    </div>
  );
};

export default React.memo(DealField);
